<template>
  <div id="settings" class="container-fluid px-0">
    <div class="main no-side-bar">
      <nav v-if="$store.state.user.authenticated">
        <TopNav></TopNav>
        <MobileNav></MobileNav>
      </nav>
      <header class="page-header bg-brand-secondary">
        <div class="content-container container">
          <div class="page-title col-12">
            <h2>{{ componentText.title }}</h2>
          </div>
        </div>
      </header>
      <main class="content-wrap">
        <div class="content-container row py-5">
          <div role="document" class="content-card w-100 p-5">
            <div class="content-inner p-md-5 m-md-5 p-0 m-0" v-html="content"></div>
            <div class="
                d-flex
                flex-column
                align-items-center
                justify-content-center
                mt-5
                brand-text
              " v-if="!this.$store.getters.user.user.pp_accepted && $store.state.user.authenticated">
              <div class="d-flex flex-row align-items-center mb-4">
                <input
                  type="checkbox"
                  id="agree-checkbox"
                  v-model="checkbox"
                  aria-label="Agree to privacy policy"
                  class="checkbox"
                />
                <label for="agree-checkbox" class="ml-2">
                  I have read and agree to the above privacy policy.
                </label>
              </div>

              <b-button
                class="cta-button px-5 pt-3 pb-4"
                :disabled="!checkbox"
                @click="agreeToPP()"
                aria-label="Agree to privacy policy"
              >
                <span v-if="agreementSuccess === false">Agree!</span>
                <span v-else>Success!</span>
              </b-button>
            </div>
            <div v-else-if="agreementSuccess" class="d-flex justify-content-center">
              <p class="brand-text">
                You have successfully agreed to the privacy policy, you'll
                be redirectly shortly..
              </p>
            </div>
          </div>
        </div>
      </main>
      <footer>
        <Footer v-if="$store.state.user.authenticated"></Footer>
      </footer>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import config from "../config/constants";
import TopNav from "@/components/TopNav.vue";
import MobileNav from "@/components/MobileNav.vue";
import Footer from "../components/Footer";
export default {
  name: "Privacy",
  components: {
    Footer,
    TopNav,
    MobileNav,
  },
  data() {
    return {
      agreementSuccess: false,
      checkbox: false,
      content: "",
      isLoading: true,
    };
  },
  mounted() {
    if (this.$route.query.lang) {
      this.$store.commit("setLanguage", this.$route.query.lang);
    }
    this.getPrivacyPolicy();
  },
  methods: {
    removeInlineStyles(htmlString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');
      const elementsWithStyle = doc.querySelectorAll('[style]');
      elementsWithStyle.forEach(el => el.removeAttribute('style'));
      return doc.body.innerHTML;
    },
    toggleCheckbox() {
      this.checkbox = !this.checkbox;
    },
    async agreeToPP() {
      if (this.checkbox) {
        const payload = {
          user_id: this.$store.getters.user_id,
          terms_type: ["pp"],
        };
        let res = await axios.post(
          config.api_env + "/application/api/u/user/accept-terms",
          payload,
          config.options
        );
        if (res.data.success) {
          let self = this;
          this.$store.dispatch("setUserPPAgreementTrue");
          this.agreementSuccess = true;
          setTimeout(function () {
            // Honour redirect_to from /loginas — see LoginAs.vue.
            const target = sessionStorage.getItem("postLoginRedirect") || "/";
            self.$router.push(target);
          }, 2000);
        } else if (res.data.err && res.data.err.includes("3994")) {
          this.$store.dispatch("logout");
          this.$router.push("/login").catch((err) => { });
        }
      }
    },
    decodeData(data) {
      try {
        return Buffer.from(data, "base64");
      } catch (error) {
        return data;
      }
    },
    async getPrivacyPolicy() {
      let slug = this.$store.getters.user.user_pp_slug;
      if (slug === 'generic_pp' && this.$store.getters.client.pp_slug) {
        slug = this.$store.getters.client.pp_slug
      }
      const payload = {
        slug,
      };
      let res = await axios.post(
        config.api_env + "/application/api/u/info/get-info",
        payload,
        config.options
      );
      if (res.data.success) {
        this.content = this.removeInlineStyles(this.decodeData(res.data.dynamic_string.string));
        this.isLoading = false;
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
        this.$router.push("/login").catch((err) => { });
      }
    },
  },
  computed: {
    componentText() {
      return this.getText.privacy;
    },
  },
  watch: {
    skin(newVal) {
      this.$store.commit("setSkin", newVal);
    },
  },
};
</script>
<style lang="less">
#settings {
  h2, h3 {
    font-family: 'Raptor V3 Black', sans-serif;
  }

  td {
    border: 1px solid black !important;
    padding: 3px;
  }

  strong {
    font-family: "DMSans Bold", sans-serif;
  }

  font-size: 1.6rem;
  font-family: "DMSans", sans-serif;

  .content-wrap {
    background: #fff;

    p, h2, h3, li {
      color: #122130;
      letter-spacing: normal;
    }

    .content-inner a {
      color: #0040ff;

      &:hover {
        color: #3366ff;
      }
    }

    .content-card {
      transform: translateY(-80px);
      background: #ffffff;
      max-width: 1000px;
      margin: auto;
    }
  }

  .checkbox {
    width: 20px;
    height: 20px;
    border: 2px solid #3a4961;
    margin-right: 8px;
  }

  label {
    margin-bottom: 0;
  }

  @media (max-width: 992px) {
    .page-header {
      padding-top: 100px;
    }

    .content-card {
      transform: translateY(0);
    }
  }

}
</style>
